"use client";

/**
 * A horizontal meter for a length budget — words on a page, minutes on a stage.
 *
 * The bar is decorative and capped at the full width; the visible text carries the real
 * figure, so an overfull page reads as over rather than as exactly full, and a screen
 * reader gets the same reading from the text.
 * Every word comes in through props.
 */
export function LengthMeter({
  label,
  value,
  max,
  valueText,
  over,
}: {
  label: string;
  value: number;
  max: number;
  /** The reading in words: "540 of 700 words". */
  valueText: string;
  /** Draws the bar in the warning colour. */
  over: boolean;
}) {
  const width = max > 0 ? Math.min(100, (value / max) * 100) : 0;
  return (
    <div className="space-y-1.5">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <span className="font-medium text-foreground text-sm">{label}</span>
        <span className="text-muted-foreground text-sm tabular-nums">
          {valueText}
        </span>
      </div>
      <div
        aria-hidden="true"
        className="h-2.5 w-full overflow-hidden rounded-full bg-muted"
      >
        <div
          className={`h-full rounded-full ${over ? "bg-destructive" : "bg-primary"}`}
          style={{ width: `${width}%` }}
        />
      </div>
    </div>
  );
}
